import React, { Component } from "react";
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem } from 'react-bootstrap';

import cross from '../assets/icons/ic-close.svg';

import './FilterBar.css';

class FilterBar extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
    onSelectSort: PropTypes.func,
    value: PropTypes.string,
    title: PropTypes.string,
    sortTitle: PropTypes.string,
    disabled: PropTypes.bool,
    collapse: PropTypes.bool,
    link: PropTypes.string,
    printName: PropTypes.string,
    filterComponent: PropTypes.node,
  }

  static defaultProps = {
    collapse: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      collapse: props.collapse,
      value: '',
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleSticky, true);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleSticky, true);
  }

 handleSticky() {
   const header = document.getElementById("FilterBar");

  if (window.pageYOffset >= 10) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  }

  handleChange = async (event) => {
    event.preventDefault();
    this.setState({
      value: event.target.value,
    });

    if(this.props.onChange) {
      this.props.onChange(event);
    }
  }

  handleSelect = async (value) => {
    if(this.props.onSelect) {
      this.props.onSelect(value);
    }    
  }

  handleSelectSort = async (value) => {
    if(this.props.onSelectSort) {
      this.props.onSelectSort(value);
    }
  }

  handlePrint = (e) => {
    e.preventDefault();
    window.open(this.props.printLink);
  }

  handleCollapse = (e) => {
    e.preventDefault();
    this.setState({collapse: !this.state.collapse});
  }

  handleText = (e) => {
    e.preventDefault();
    this.setState({ value: e });
  }

  handleClear = (e) => {
    e.preventDefault();
    this.setState({ value: '' });
  }

  renderDropDown() {
    return (
      <DropdownButton
        title={this.props.title}
        id="filterData"
        disabled={this.props.disabled}
      >
        {
          this.props.types && this.props.types.map((obj, i) => (
            <MenuItem
              key={i}
              eventKey={obj}
              onSelect={this.handleSelect}
            >
              {obj.label}
            </MenuItem>
          ))
        }
      </DropdownButton>
    );
  }

  renderSortDropDown() {
    return (
      <DropdownButton
        title={this.props.sortTitle}
        id="sortData"
        disabled={this.props.disabled}
      >
        {
          this.props.sortTypes && this.props.sortTypes.map((obj, i) => (
            <MenuItem
              key={i}
              eventKey={obj}
              onSelect={this.handleSelectSort}
            >
              {obj.label}
            </MenuItem>
          ))
        }
      </DropdownButton>
    );
  }

  render() {
    const {disabled, filterComponent} = this.props;
    return (
      <div id="FilterBar">
        <div className="barWrapper">
          <div className="left">
            <span className="searchBarWrapper">
              <input
                type="text"
                placeholder="Search"
                name="search"
                ref="filterTextInput"
                value={this.state.value}
                onChange={this.handleChange}
                disabled={disabled}
                />
              {
                this.state.value !== '' ?
                <button className="buttonLink" onClick={this.handleClear}>
                  <img src={cross} alt="clear"/>
                </button>
                : null
              }
            </span>

            {this.renderDropDown()}
            <span className="sort">Sort By: {this.renderSortDropDown()}</span>
            { filterComponent ? filterComponent : null }
          </div>

          {
            this.props.printName &&
            <div className="right">
              <button className="Button primary" onClick={this.handlePrint}>
                {this.props.printName}
              </button>
              {
                this.props.collapse ?
                <button className="buttonLink" onClick={this.handleCollapse}>
                  {this.state.collapse ? "Open All" : "Collapse All"}
                </button>
                : null
              }
            </div>
          }
        </div>
      </div>
    );
  }
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/FilterBar.jsx